import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles';
import BatchDashboardCardView, { BatchDashboardPlainCard } from './BatchDashboardCardView';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '../utility/styles';
import { Link } from '../utility/Link';
import { IBatchModel } from './CreateBatchModel';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    flex: '0 0 auto',
    overflowY: 'auto',
    flexDirection: 'column',
  },
  list: {
    display: 'flex',
    justifyContent: 'center',
    margin: '8px',
  },
  paper: {
    padding: '16px',
    marginRight: '16px',
    '&:last-child': {
      marginRight: '0px',
    },
  },
  link: {
    color: 'rgb(36, 27, 26)',
    textDecoration: 'none',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: -6,
    marginBottom: 4,
  },
  divider: {},
  timecardInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
});

interface IProps {
  className?: string;
  model: IBatchModel;
}

type Props = WithStyle<ReturnType<typeof styles>, IProps>;

class BatchDashboardView extends React.PureComponent<Props> {
  render() {
    const { classes } = this.props;
    const model = this.props.model;

    return (
      <div className={classes.root}>
        <Observe
          render={() => (
            <div className={classes.list}>
              <Paper className={classes.paper} elevation={3}>
                <BatchDashboardPlainCard model={model.totalEmployees} />
              </Paper>

              <Paper className={classes.paper} elevation={3}>
                <Typography className={classes.title} variant="h5">
                  Timecard Counts
                </Typography>
                <Divider />
                <div className={classes.timecardInfoContainer}>
                  <Link key={model.notInBatch.name} className={classes.link} to={model.notInBatch.uri}>
                    <Button tabIndex={-1} disabled={!model.notInBatch.enabled}>
                      <BatchDashboardCardView model={model.notInBatch} />
                    </Button>
                  </Link>
                  {model.inBatch.visible && (
                    <Link key={model.inBatch.name} className={classes.link} to={model.inBatch.uri}>
                      <Button tabIndex={-1} disabled={!model.inBatch.enabled}>
                        {' '}
                        <BatchDashboardCardView model={model.inBatch} />
                      </Button>
                    </Link>
                  )}
                  <Link key={model.inError.name} className={classes.link} to={model.inError.uri}>
                    <Button tabIndex={-1} disabled={!model.inError.enabled}>
                      <BatchDashboardCardView model={model.inError} />
                    </Button>
                  </Link>
                </div>
              </Paper>

              {model.statuses.length > 0 && (
                <Paper className={classes.paper} elevation={3}>
                  <Typography className={classes.title} variant="h5">
                    Timecard Status
                  </Typography>
                  <Divider />
                  <div className={classes.timecardInfoContainer}>
                    {model.statuses.map((e) => (
                      <Link key={e.name} className={classes.link} to={e.uri}>
                        <Button tabIndex={-1}>
                          <BatchDashboardCardView model={e} />
                        </Button>
                      </Link>
                    ))}
                  </div>
                </Paper>
              )}
            </div>
          )}
        />
      </div>
    );
  }
}

export default withStyles<IProps>(styles, BatchDashboardView);
